//@ts-nocheck
import localEn from "../translations/en";
import localEs from "../translations/es";
import localKhm from "../translations/khm";
import localAr from "../translations/ar-ae";
import localBg from "../translations/bg";

import sharedEn from "sentec-vues/translations/en";
import sharedEs from "sentec-vues/translations/es";
import sharedKhm from "sentec-vues/translations/khm";
import sharedAr from "sentec-vues/translations/ar-ae";
import sharedBg from "sentec-vues/translations/bg";

const supported = ["en", "es", "khm", "ar-ae", "bg"];
let locale = "en";
try {
  const { 0: browserLang } = navigator.language.split("-");
  if (supported.includes(browserLang)) locale = browserLang;
} catch (e) {
  console.error(e);
}

export default {
  locale,
  fallbackLocale: "en",
  availableLocales: [{
    code: "en",
    flag: "us",
    label: "English",
    messages: { ...sharedEn, ...localEn },
    thousands_separator: ",",
    decimal_separator: "."
  }, {
    code: "es",
    flag: "es",
    label: "Spanish",
    messages: { ...sharedEs, ...localEs },
    thousands_separator: ".",
    decimal_separator: ","
  },
  {
    code: "khm",
    flag: "khm",
    label: "ខ្មែរ (Cambodian Khmer)",
    messages: { ...localKhm, ...sharedKhm },
    thousands_separator: ".",
    decimal_separator: ","
  },
  {
    code: "ar-ae",
    flag: "ae",
    label: "Arabic (United Arab Emirates)",
    messages: { ...localAr, ...sharedAr },
    thousands_separator: ".",
    decimal_separator: ","
  },
  {
    code: "bg",
    flag: "bg",
    label: "Bulgarian",
    messages: { ...localBg, ...sharedBg },
    thousands_separator: ".",
    decimal_separator: ","
  }]
};
